import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  root: {
    padding: 15,
    backgroundColor: 'rgba(0,0,0,0.7)',
    //opacity: 0.6,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
